export class OrderInboxModel {
	id?: number;
	clientReferenceId?: string;
	clientReferenceProvider?: string;
	completed?: boolean;
	completedDate?: string;
	created?: string;
	description?: string;
	documentId?: string;
	enteredBy?: any;
	formType?: string;
	orderedBy?: any;
	product?: any;
	productType?: any;
	reOpened?: boolean;
	reviewer?: any;
	revised?: boolean;
	schema?: string;
	state?: number;
	stateEnum?: string;
	status?: string;
	tenantId?: number;
	tenantName?: any;
}

export interface TrackingOption {
	id: string; 
	title: string;
}

export class AutoQCStatusModel {
	isValid: boolean;
	message: string;
	key: AutoQCStatusKeyModel;

	constructor() {
		this.isValid = false;
		this.message = 'Initializer message';
		this.key = new AutoQCStatusKeyModel;
	}
}

export class AutoQCStatusKeyModel {
	id: string;
	orderId: string;
	documentId: string;
	requiresRulesValidation: boolean;
	rulesValidationPassed: boolean;
	rulesValidationdDate?: Date;
	requiresCUScoreValidation: boolean;
	cuScoreValidationDate?: Date;
	cuScore: string;
	cuScoreValidationPassed: boolean;
	smartQCConfigurationId: string;
	cuScoreValidationMessage: string;
	ruleValidationMessage: string;

	constructor() {
		this.id = '';
		this.orderId = '';
		this.documentId = '';
		this.requiresRulesValidation = false;
		this.rulesValidationPassed = false;
		this.rulesValidationdDate = undefined;
		this.requiresCUScoreValidation = false;
		this.cuScoreValidationDate = undefined;
		this.cuScore = '';
		this.cuScoreValidationPassed = false;
		this.smartQCConfigurationId = '';
		this.cuScoreValidationMessage = '';
		this.ruleValidationMessage = '';
	}
}
